import { useEffect, useMemo, useState } from 'react'
import util from '../helpers/util.helper'
import { UserStorage } from '../types'
import secureHelper from '../helpers/secure.helper'
import { Buffer } from 'buffer';

export default function useUserStorage<T>(key: string, userStorage: UserStorage = 'local') {
    const secKey = useMemo(() => Buffer.from(secureHelper.encriptApiRequest(key, process.env.REACT_APP_CYPHER || '')).toString('base64'), [key])
    const [data, setData] = useState<T | null>(util.readUserStorage({ key: secKey, userStorage, encrypted: true }))
    useEffect(() => {
        if (data !== null && data !== undefined) {
            util.saveUserStorage({ key: secKey, userStorage, value: data, encrypted: true })
        } else {
            localStorage.removeItem(secKey)
        }
    }, [data])
    return { data, setData }
}